{
  "noDataText": "No devices found",
  "name": "Name",
  "user": "User",
  "tableOpenRowButton": "Show",
  "apiError": "Fetching device data failed",
  "searchAssets": {
    "searchLabel": "Find device by...",
    "scope": {
      "name": "Name of user",
      "namePlaceholder": "E.g. “andersson”",
      "phoneNumber": "Phone number of user",
      "phoneNumberPlaceholder": "E.g. “+4711112222”",
      "email": "Email of user",
      "emailPlaceholder": "E.g. “john.doe@example.com”",
      "imei": "IMEI",
      "imeiPlaceholder": "E.g. “1234567890123456”",
      "locationReference": "Location reference",
      "locationReferencePlaceholder": "E.g. “Shop“",
      "orderId": "Order number",
      "orderIdPlaceholder": "E.g. “CDAAS-1234567”"
    },
    "filters": {
      "all": "All",
      "active": "Active",
      "inactive": "Inactive",
      "filterActivityLabel": "Show devices",
      "filterEndOfLeaseLabel": "Show only devices waiting end of lease selection",
      "filterWaitingForReturnLabel": "Show only devices waiting for return"
    }
  },
  "details": {
    "deviceInformationTitle": "Device information",
    "goBackToList": "Back to devices",
    "assetNotFound": "Device not found with ID {{id}}",
    "assetSyncError": "Check with Telia Finance",
    "monthShort": "month",
    "months": "months",
    "monthsLeft": "months left",
    "monthLeft": "month left",
    "vatIncluded": "(incl. VAT)",
    "validUntil": "Valid until",
    "deviceDetails": "More information",
    "imeiNumber": "IMEI",
    "events": "Events",
    "tickets": "Tickets",
    "link": "Link",
    "replacedDeviceTag": "Replaced device",
    "contractEndedDate": "Lease period ended",
    "deviceBought": "device purchased",
    "deviceAwaitingReturn": "pending return",
    "deviceReturnInTransit": "return in transit",
    "deviceReturnReceived": "received and awaiting assessment",
    "deviceReturnedApproved": "returned in good condition",
    "deviceReturnedWithCloudLock": "cloud lock detected, awaiting unlocking",
    "deviceReturnedWithConditions": "returned with damages",
    "deviceNotReturnedInvoiced": "not returned, invoiced",
    "incorrectDeviceReturned": "incorrect device received",
    "otherReturnStatus": "return device selected",
    "deviceReturned": "device returned",
    "deviceNotReturned": "device was never returned",
    "location": "Location",
    "locationReference": "Location reference",
    "invoicingAccount": "Invoicing account",
    "activeInvoicingAccount": "Active invoicing Account",
    "user": "User",
    "userName": "Name",
    "phoneNumber": "Phone number",
    "otherDevices": "Other devices",
    "createTicketButton": "Create service ticket for damaged device",
    "createSecondTicketButton": "Create service ticket for stolen device or other issues",
    "secondTicketModal": {
      "title": "Stolen device or other questions",
      "content": "Customer support will handle the ticket creation based on request.",
      "button": "Close"
    },
    "previousImeis": "Previous IMEIs",
    "sku": "SKU",
    "bundleAccessories": "Accessories",
    "bundleOrderId": "Order id",
    "bundleServices": "Services",
    "insurance": "Insurance",
    "ticketStatus": "status",
    "ticketOpen": "Open",
    "ticketClosed": "Closed",
    "contractEnded": "Lease period ended",
    "contractExtended": "Lease period extended by",
    "endOfLeaseSelected": "End of lease selected",
    "returnEnvelopeSent": "Return package sent to user",
    "endOfLeaseReturnColtHardwareDeliveryId": "COLT hardware delivery id for the return package",
    "delivered": "Delivered",
    "shipped": "Shipped",
    "assignToDifferentUser": "Assign device to new user",
    "assignToOrganization": "Assign device to organization",
    "inactiveAssetInvoicingAccount": "Not applicable due to expired lease period",
    "assign": {
      "deviceToBeAssigned": {
        "name": "Device name",
        "price": "Price",
        "currentUser": "Current user",
        "currentInvoicingAccount": "Current invoicing account"
      },
      "selectUserInput": {
        "label": "Find new user",
        "placeholder": "Search..."
      },
      "userToAssignDeviceTo": {
        "nameAndGroup": "Name and group",
        "contact": "Contact",
        "deviceLimit": "Device limit",
        "maxPricePaidByEmployer": "Max price/device paid by employer"
      },
      "newInvoicingAccount": {
        "label": "New invoicing account",
        "dropdownLabelUser": "Current invoicing account",
        "clearSelection": "Clear selection",
        "noOptionsFoundInfo": "No invoicing account options found",
        "helperText": "Selected invoicing account will be saved and the unit will be invoiced on the new invoicing account."
      },
      "month": "month",
      "months": "months",
      "unlimited": "unlimited",
      "leaseContinueInfo": {
        "part1": "The lease will continue under the new user. There is",
        "part2": "of the agreement period left"
      },
      "modalHeadingOrganization": "Assign to organization",
      "modalHeadingUser": "Assign to user",
      "saveButton": "Save changes",
      "cancelButton": "Cancel",
      "errors": {
        "userDetailLoadingApiError": "Could not load user details",
        "cantBeAssignedBecauseOfSingleDevicePolicyError": "This user already has a device (or has an order pending)",
        "assignApiError": "Assigning device failed. You can try again later."
      },
      "confirmationModal": {
        "titleOrganization": "Confirm organization assignment",
        "titleUser": "Confirm with recipient",
        "confirmInfoOrganization": "Please confirm assignment of the device to the organization with the following details:",
        "confirmInfoUser": "Please confirm that the recipient of this device is aware of and agrees with the following details:",
        "confirmList": {
          "device": "The device is",
          "price": "The price of the device is",
          "remainingLeasePeriod": {
            "remainingLeasePeriod": "The remaining agreement period is",
            "outOf": "out of"
          },
          "allowance": {
            "allowance": "There is a max price/device covered by the employer for this user",
            "possibleSalaryDeduction": "some amount may be deducted from their salary, depending on how much has already been paid under the previous user"
          },
          "deviceLimit": "The user has used their purchase right for 1 out of 1 devices"
        },
        "vatIncluded": "incl. VAT",
        "month": "month",
        "months": "months",
        "confirmButton": "Confirm",
        "cancelButton": "Cancel"
      },
      "errorFetchingOrganizationUsers": "Fetching possible target users list failed",
      "assetAssignSuccessful": "Device assigned successfully"
    },
    "endOfLeaseNotifications": {
      "contractEndsTitle": "Lease period ends soon",
      "contractEndsTitleUpgrade": "Device can be upgraded",
      "decisionNotYetDoneMessageExtension": "Please select what to do. If no selection is made, the lease will be extended by three months.",
      "decisionNotYetDoneMessageExtensionRecurring": "Make a selection regarding this device. If no selection is made, the agreement will be extended monthly until a selection is made.",
      "decisionNotYetDoneMessageLeaseEnd": "This device can now be upgraded. Make a selection regarding this device. If no selection is made, the agreement will be cancelled, and the device will be invoiced.",
      "daysLeftForDecision": "Days left to make a decision ",
      "daysLeftForDecisionRecurring": "Days left to make a decision before monthly extension ",
      "daysLeftForDecisionLast": "Days left to make a decision before agreement is cancelled ",
      "buyoutTitle": "Purchase has been selected for the device after the end of the current lease period",
      "buyoutMessage": "If the user won’t use the device for work anymore, they should reset the device to remove employer related configuration and data.",
      "returnTitle": "Return has been selected for the device at the end of the current lease period",
      "returnMessage": "User will receive a postage package along with instructions for returning the device.",
      "waitingForBuyoutPriceTitle": "Waiting for price",
      "waitingForBuyoutPriceMessage": "The price should appear shortly. Please refresh the page in a few minutes."
    },
    "eolActionEventMessage": {
      "buyoutSelectedEvent": "User selected \"Purchase the device\" at the end of the lease agreement",
      "returnDeviceEvent": "User selected \"Return the device\" at the end of the lease agreement",
      "notReturnedEvent": "Automatically marked the device as not returned, because the user didn't make an end-of-lease selection"
    },
    "endOfLeaseGrowlNotifications": {
      "decisionError": "Error while making end of lease decision.",
      "decisionSuccessful": "End of lease decision made successfully.",
      "decisionDraftConfirmOrCancelError": "Error while confirming or cancelling end of lease draft request.",
      "priceRequestCancelled": "Price request cancelled.",
      "priceRequestError": "Error while asking for buyout price."
    },
    "assetActionPostError": "Failed to perform device action",
    "assetUpdatePutError": "Failed to update asset",
    "invoicingAccountSelection": {
      "dropdownLabel": "Current invoicing account",
      "clearSelection": "Clear selection",
      "noOptionsFoundInfo": "No invoicing account options found",
      "helperText": "Selected invoicing account will be saved and the unit will be invoiced on the new invoicing account.",
      "errorMessage": "Account not found",
      "accountNotValidTitle": "Wrong account",
      "accountNotValidMessage": "This invoicing account is not used anymore. Select correct account from the list."
    },
    "midLeaseBuyout": {
      "confirmButton": "Purchase",
      "cancelButton": "Cancel",
      "purchaseConfirmationCheckboxLabel": "I confirm my purchase and understand that this decision is final and cannot be reversed.",
      "withoutPrice": {
        "optionTitle": "Purchase the device (mid-lease termination)",
        "optionText": "If you select to purchase the device, the agreement will be terminated in the middle of the lease. Depending on whether the next month is already invoiced, the termination date will be at the end of this month or at the end of next month.",
        "optionButton": "Purchase device",
        "modalTitle": "Purchase device (mid-lease termination)",
        "modalText1": "The purchase price is not currently available here, but you can still purchase the device.",
        "confirmedTitle": "Request to purchase device confirmed",
        "confirmedText": "Depending on whether the next month is already invoiced, the agreement will end at the end of this month or at the end of next month.",
        "confirmedButton": "Ok"
      },
      "withPrice": {
        "askForPriceButton": "Ask for price",
        "waitingForPrice": "Waiting for price...",
        "purchaseAnywayButton": "Purchase anyway",
        "purchaseButton": "Purchase device",
        "purchaseDevicePriceName": "Price:",
        "purchaseDevicePriceIncludingVat": "(incl. VAT)",
        "purchaseDevicePriceExcludingVat": "(excl. VAT)",
        "purchaseDeviceOption": "Purchase the device (mid-lease termination)",
        "purchaseDeviceText": "View the price of the unit here. If you select to purchase the device, the agreement will be terminated in the middle of the lease. Depending on whether the next month is already invoiced, the termination date will be at the end of this month or at the end of next month.",
        "priceAvailableModal": {
          "title": "Do you want to purchase the device?",
          "generalInfo": {
            "paragraph1": "The agreement will be terminated in the middle of the lease.",
            "paragraph2": "Depending on whether the next month is already invoiced, the termination date will be at the end of this month or at the end of next month."
          }
        },
        "priceNotAvailableModal": {
          "title": "No price available (mid-lease termination)",
          "content": {
            "description": "Getting the purchase fee for this device is taking too long. We may need to check it manually.",
            "optionsTitle": "Choose one:",
            "optionWait": "Wait for the price",
            "optionPurchaseAnyway": "Purchase anyway, without seeing the exact sum beforehand.",
            "optionCancel": "Cancel and select a different option.",
            "cancelButton": "Cancel",
            "waitButton": "Wait for price",
            "purchaseButton": "Purchase anyway"
          }
        },
        "purchaseAssetAnywayModal": {
          "title": "Purchase device?",
          "content": {
            "paragraph1": "The price is currently not available. If you don’t want to wait for the price, you can confirm your purchase anyway.",
            "paragraph2": "The agreement will be terminated in the middle of the lease.",
            "paragraph3": "Depending on whether the next month is already invoiced, the termination date will be at the end of this month or at the end of next month.",
            "confirmButton": "Purchase",
            "cancelButton": "Cancel"
          }
        }
      }
    },
    "midLeaseReturn": {
      "returnDeviceOptionTitle": "Return device (mid-lease termination)",
      "returnDeviceOptionText": "If you select to return the device, the agreement will be terminated in the middle of the lease. Depending on whether the next month is already invoiced, the termination date will be at the end of this month or at the end of next month.",
      "returnDeviceOptionButton": "Return device",

      "returnDeviceModalTitle": "Before proceeding with the return (mid-lease termination)",
      "returnDeviceModalText1": "Do you want to return the device?",
      "returnDeviceModalText2": "Once the return has been selected, the decision is final and the device must be returned within 30 days. If the device is returned in the middle of lease, it may have additional costs which will be invoiced from the company.",
      "returnDeviceModal": {
        "nextSteps": "If the device will be returned within 30 days, please complete the following steps:",
        "step1": "Choose whether the user wants the return box delivered to the home mailbox or to the company’s postal address.",
        "step2": "Enter the name of the recipient for the return box.",
        "step2Detail": "This applies to both home and company deliveries.",
        "step3": "Enter the postal address where the return box should be delivered.",
        "step3Detail": "For home deliveries, ensure the mailbox is clearly marked with the recipient’s name and house number. For company deliveries, provide the company’s P.O. Box.",
        "step4": "Enter the email and phone number of the person who will carry out the return.",
        "step4Detail": "Used as primary contact for return."
      },
      "returnDeviceModalContinueButton": "Continue",
      "returnDeviceModalCancelButton": "Cancel",

      "returnDeviceReturnableDeviceTitle": "Device to be returned",
      "returnDeviceReturnableDeviceText1": "No need to return any addons that were delivered with the device (headphones, protective covers, etc.).",
      "returnDeviceReturnableDeviceText2": "Only the main device itself should be returned.",

      "returnDeviceReturnConfirmedHeadline": "Thank you for selecting return",
      "returnDeviceReturnConfirmedNextButton": "Done",
      "returnDeviceReturnConfirmedText1": "Telia will send a return box for returning the device.",
      "returnDeviceReturnConfirmedText2": "Please request to remove any cloud lock, 'Find My', or 'Find My iPhone' from the device before returning it.",
      "returnDeviceReturnConfirmedText3": "Please ensure the mailbox and door are clearly labeled with the name and house number.",

      "returnDeviceOrderReturnEmployeeTitle": "User",
      "returnDeviceOrderReturnDeliveryTitle": "Order the return box for the selected device",
      "returnDeviceOrderReturnDeliveryText": "The return box will be sent by trackable letter to the recipient's mailbox.",
      "returnDeviceOrderReturnRecipientText": "Recipient of the return box",
      "returnDeviceOrderReturnContactText": "Please add contact details of the person handling the return.",
      "returnDeviceOrderReturnDeliveryQuestion": "Is this a company or a home address?",
      "returnDeviceOrderReturnCompanyName": "Company name",
      "returnDeviceOrderReturnFirstName": "First name",
      "returnDeviceOrderReturnLastName": "Last name",
      "returnDeviceOrderReturnEmail": "Email",
      "returnDeviceOrderReturnPhoneNumber": "Phone number",
      "returnDeviceOrderReturnStreet": "Post address or P.B number",
      "returnDeviceOrderReturnCity": "City",
      "returnDeviceOrderReturnPostalCode": "Postal code",
      "returnDeviceOrderReturnCountry": "Country",
      "returnDeviceOrderReturnCountryPlaceholder": "Select country",
      "returnDeviceOrderReturnHomeDeliveryOption": "Home address",
      "returnDeviceOrderReturnHomeDeliveryOptionDetails": "Please provide the home address and ensure the mailbox is clearly labeled with the name and house number.",
      "returnDeviceOrderReturnCompanyDeliveryOption": "Company address",
      "returnDeviceOrderReturnCompanyDeliveryOptionDetails": "Please provide the post box address and the name of the internal recipient within the company.",
      "returnDeviceOrderReturnRequired": "required",
      "returnDeviceOrderReturnInvalidEmail": "Invalid email",
      "returnDeviceOrderReturnInvalidPhoneNumber": "Invalid phone number",
      "returnDeviceOrderReturnInvalidPostalCode": "Invalid postal code",
      "returnDeviceConfirmationCheckboxLabel": "I confirm the return and understand that this decision is final and cannot be reversed.",
      "returnDeviceOrderReturnNextButton": "Confirm",
      "returnDeviceOrderReturnCancelButton": "Cancel"
    },
    "midLeaseGrowlNotifications": {
      "decisionError": "Error while making mid-lease decision.",
      "decisionSuccessful": "Mid-lease decision made successfully."
    }
  }
}
